/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

function MoodsIcon({ mainColor, secondaryColor }) {
  return (
    <svg
      width="157"
      height="157"
      viewBox="0 0 157 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon-moods">
        <g id="Group 70 Copy 2">
          <g id="Group 68 Copy 2">
            <g id="Group 66 Copy 2">
              <g id="Group 65 Copy 2">
                <g id="Group 63 Copy 2">
                  <g id="Group 61 Copy 2">
                    <g id="Group 59 Copy 3">
                      <g id="icon-legal and finance copy">
                        <g id="Group 58 Copy 2">
                          <g id="icon-journey-course">
                            <circle
                              id="Oval"
                              cx="78.5"
                              cy="78.5"
                              r="77.5"
                              fill={mainColor}
                              stroke="white"
                              stroke-width="2"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="good-mood-emoticon">
          <path
            id="Shape"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M36 80.5C36 57.125 55.125 38 78.5 38C101.875 38 121 57.125 121 80.5C121 103.875 101.875 123 78.5 123C55.125 123 36 103.875 36 80.5ZM99.75 69.875C99.75 66.475 96.775 63.5 93.375 63.5C89.975 63.5 87 66.475 87 69.875C87 73.275 89.975 76.25 93.375 76.25C96.775 76.25 99.75 73.275 99.75 69.875ZM63.625 63.5C67.025 63.5 70 66.475 70 69.875C70 73.275 67.025 76.25 63.625 76.25C60.225 76.25 57.25 73.275 57.25 69.875C57.25 66.475 60.225 63.5 63.625 63.5ZM54.7 89C58.1 98.775 67.45 106 78.5 106C89.55 106 98.9 98.775 102.3 89H54.7Z"
            fill={secondaryColor}
          />
        </g>
      </g>
    </svg>
  );
}

MoodsIcon.propTypes = {
  mainColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};
MoodsIcon.defaultProps = {
  mainColor: '#7ED321',
  secondaryColor: '#FFFFFF',
};

const memoized = React.memo(MoodsIcon);
memoized.displayName = 'MoodsIcon';
export default memoized;
